module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Conversations":"Konversationen","Form entries":"Formulareinträge"}}')
  delete Component.options._Ctor
}
